import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'
import '../App.css';

var firebase = require('firebase/app');
require('firebase/database');
var config = {
  apiKey: "AIzaSyDagjpDFyrc-KBdRYVB9Fh3PF100-L7wkQ",
  authDomain: "sancochero-51ea9.firebaseapp.com",
  databaseURL: "https://sancochero-51ea9.firebaseio.com",
  projectId: "sancochero-51ea9",
  storageBucket: "sancochero-51ea9.appspot.com",
  messagingSenderId: "25612294936"
};

if (!firebase.apps.length) {
    firebase.initializeApp(config);
} else {
    firebase.app();
}

var firebaseui = require('firebaseui');

var ui = new firebaseui.auth.AuthUI(firebase.auth());

class Login extends Component {
    constructor() {
    super();
    this.state = {
      user: false
      }
  }
    
  componentWillMount() {
      console.log('params: ', this.props.match.params)
      this.getUser();
  }
    
  getUser() {
    if (!firebase.apps.length) {
        this.setState({
            user: true
        })
    } else {
        console.log('FBAppLength: ', firebase.apps.length)
    }
  }

  render() {
      var uiConfig = {
          callbacks: {
            signInSuccessWithAuthResult: function(authResult, redirectUrl) {
              return true;
            },
            uiShown: function() {
              document.getElementById('loader').style.display = 'none';
            }
          },
          signInFlow: 'popup',
          signInSuccessUrl: '/teamreg/' + this.props.match.params.tourId,
          signInOptions: [
            firebase.auth.EmailAuthProvider.PROVIDER_ID,
          ],
          tosUrl: '<your-tos-url>',
          privacyPolicyUrl: '<your-privacy-policy-url>'
        };
      ui.start('#firebaseui-auth-container', uiConfig);
    return (
      <div className="App">
        <div id="firebaseui-auth-container"></div>
        <div id="loader">Loading...</div>
      </div>
    );
  }
}

export default Login;


// WEBPACK FOOTER //
// ./src/pages/Login.js